import * as React from 'react';
import { Button, Form, Header, GridRow, Segment, Select } from 'semantic-ui-react';

import configs from '../helpers/config';
import "../helpers/styles.css";

const conselhoOptions = [
    { key: 'CRM', value: 'CRM', text: 'CRM' },
    { key: 'Outro', value: 'Outro', text: 'Outro' }
]

const ufOptions = [
    { key: 'PR', value: 'PR', text: 'PR' },
    { key: 'SP', value: 'SP', text: 'SP' },
    { key: 'SC', value: 'SC', text: 'SC' },
    { key: 'RS', value: 'RS', text: 'RS' },
    { key: 'RJ', value: 'RJ', text: 'RJ' },
    { key: 'MG', value: 'MG', text: 'MG' }
]

class MedicosRegistro extends React.Component {
    constructor(props) {
        super(props);
        this.state = { conselho: '', uf: '', numeroConselho: '', email: '', nome: '', telefone: '' };
    }

    handleRegistro() {
        const { conselho, uf, numeroConselho, email, nome, telefone } = this.state;
        if (conselho) {
            if (uf) {
                if (numeroConselho && numeroConselho.trim().length > 0) {
                    const regexEmail = (/\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/);
                    if (regexEmail.test(email)) {
                        if (nome && nome.trim().length > 0) {
                            if (telefone) {
                                window.grecaptcha.ready(() => {
                                    window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: 'PortalResultadosMedicosRegistro' }).then(token => {
                                        this.setState({ recaptcha_token: token });
                                        this.props.onClick({ ...this.state });
                                    });
                                });
                            } else {
                                alert('Telefone deve ser informado');
                            }
                        } else {
                            alert('Nome deve ser informado');
                        }
                    } else {
                        alert('Email informado é inválido');
                    }
                } else {
                    alert('Número Conselho deve ser informado');
                }
            } else {
                alert('UF deve ser informada');
            }
        } else {
            alert('Conselho deve ser informado');
        }
    }

    handleTelefone = (e) => {
        let tel = e.target.value;

        tel = tel.replace(/\D/g, "")

        if (tel.length > 11) {
            tel = tel.substring(0, 11);
        }

        tel = tel.replace(/^(\d)/, "($1")
        tel = tel.replace(/(.{3})(\d)/, "$1) $2")
        if (tel.length === 10) {
            tel = tel.replace(/(.{1})$/, "-$1")
        } else if (tel.length === 11) {
            tel = tel.replace(/(.{2})$/, "-$1")
        } else if (tel.length === 12) {
            tel = tel.replace(/(.{3})$/, "-$1")
        } else if (tel.length === 13) {
            tel = tel.replace(/(.{4})$/, "-$1")
        } else if (tel.length > 13) {
            tel = tel.replace(/(.{4})$/, "-$1")
        }

        this.setState({ telefone: tel });
    }

    handleNumeroConselho = (e) => {
        let numero = e.target.value.replace(/\D/g, "")
        this.setState({ numeroConselho: numero });
    }

    render() {
        return (
            <Segment className={this.props.className}>

                <Header as='h2'  >
                    <p className='headerLogin'>Registro de Médico</p>
                </Header>

                <Form size='large'>
                    <GridRow >
                        <Form.Field fluid
                            control={Select}
                            placeholder='Conselho'
                            options={conselhoOptions}
                            value={this.state.conselho}
                            onChange={(e, result) => this.setState({ conselho: result.value })}
                        />
                        <Form.Field fluid
                            control={Select}
                            placeholder='UF'
                            options={ufOptions}
                            value={this.state.uf}
                            onChange={(e, result) => this.setState({ uf: result.value })}
                        />
                        <Form.Input
                            fluid
                            icon='pencil'
                            iconPosition='left'
                            placeholder='Número Conselho'
                            value={this.state.numeroConselho}
                            onChange={this.handleNumeroConselho}                            
                        />
                        <Form.Input
                            fluid
                            icon='at'
                            iconPosition='left'
                            placeholder='Email'
                            value={this.state.email}
                            onChange={(e) => this.setState({ email: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon='user'
                            iconPosition='left'
                            placeholder='Nome'
                            value={this.state.nome}
                            onChange={(e) => this.setState({ nome: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon='phone'
                            iconPosition='left'
                            placeholder='Telefone'
                            value={this.state.telefone}
                            onChange={this.handleTelefone}
                        />
                        <Button fluid size='large' onClick={() => this.handleRegistro()}>
                            Solicitar
                        </Button >
                    </GridRow>
                </Form>

            </Segment>);
    }
}

export default MedicosRegistro;